/**
 * @fileoverview Agent definition for draft-blender-v1.
 *
 * This agent takes multiple existing drafts of the same chapter and produces
 * a single "best of breed" blended version — lifting the strongest elements
 * of each candidate while minimizing their weaknesses.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'draft-blender-v1',
  kind: 'primitive',
  name: 'Draft Blender',
  description: 'Blends multiple chapter drafts into a single "best of breed" version by lifting the strongest elements of each.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-draft-blender.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
      'chapter-drafter-v2',
    ],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-opus-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
  ],
};
